module.exports = __webpack_public_path__ + "media/images/logo_mr-8d3feb271a4639dedafc0692f0fd9de6.svg";